export default __webpack_public_path__ + "static/action-item-a5789f3d56c077700e10598139301e54.wav";